import { CallbackObject } from 'api/core/get-page-function';
import { plainToClass } from 'class-transformer';
import { AxiosResponse } from 'axios';
import { instance } from 'api/core';
import { GetTeamsVm } from './get-teams.vm';

export const getTeams = async (offset: string, warehouseId: string | null, role: string | null, callback: CallbackObject<GetTeamsVm>) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
    params: {
      limit: 50,
      offset: offset,
      ...(warehouseId && { warehouseId }),
      ...(role && { role }),
    }
  };

  try {
    const res: AxiosResponse = await instance.get(`/management/teams`, config);
    callback.success(plainToClass(GetTeamsVm, res.data));
  } catch (err) {
    if (callback.error) callback.error(err);
  }
};
